import LandDetailPage from './LandDetailPage.container'
export default LandDetailPage
